import * as firebase from "firebase";

// initial state
const state = {
  reporters: null,
  devices: null,
  alarms: [],
  alarm_stats: {
    prio0: 0,
    prio1: 0,
    prio2: 0,
  },
  firebase_config: {
    apiKey: "AIzaSyCTcS-DsUyVQSheluYv2qkLIS_iL6e2BJs",
    authDomain: "biogas-central.firebaseapp.com",
    databaseURL: "https://biogas-central.firebaseio.com",
    projectId: "biogas-central",
    storageBucket: "biogas-central.appspot.com",
    messagingSenderId: "211180707735",
    appId: "1:211180707735:web:6110af84f50d6f753d6ed2"
  },
}

// getters
const getters = {

  reporters(state){
    return state.reporters
  },
  devices(state){
    return state.devices
  },
  alarms(state){
    return state.alarms
  },
  alarm_stats(state){
    return state.alarm_stats
  },
  
};

// actions
const actions = {

}

// mutations
const mutations = {

  set_reporters (state, reporters) {

    if(reporters !== null){
      
      let _this = this ; 
      var devices = [] ;

      reporters.forEach(function(reporter){

        reporter.status = null ; 

        let firebaseIndex = firebase.apps.findIndex(function( obj ) {
            return obj.name_ === 'reporter'+reporter.id;
        });

        if(firebaseIndex === -1){
          reporter.firebase = firebase.initializeApp(state.firebase_config, 'reporter'+reporter.id);
        }else{
          reporter.firebase = firebase.apps[firebaseIndex] ;
        }

        var db_instance = reporter.firebase.firestore();

        // save the devices seperate
        reporter.devices.forEach(function(device){

          device.db = db_instance
          .collection("reporters").doc(reporter.code)
          .collection("devices").doc(device.id.toString()) ;

          devices.push(device);

        })

        state.devices = devices
        delete reporter.devices ;

        reporter.firebase.auth().signInWithCustomToken(reporter.auth.token).then(function() {

          let db_instance = reporter.firebase.firestore();
          
          reporter.db = db_instance.collection("reporters").doc(reporter.code);

          reporter.db.onSnapshot(function(doc) {

            _this.commit("reporters/set_reporter_status", {
              reporter_id: reporter.id, 
              status: doc.data().status
            }) ; 

          });

          let devices = state.devices.filter(function( obj ) {
            return obj.reporter_id === reporter.id ;
          });
          
          devices.forEach(function(device){
            
            let alarmsCollection = device.db.collection('alarms') ;

            alarmsCollection = alarmsCollection.where('value', '==', '1');
        
            alarmsCollection.onSnapshot(function(querySnapshot) {

              querySnapshot.forEach(function(doc) {

                let alarm = doc.data() ;
                alarm.id = doc.id ;
                alarm.reporter_id = reporter.id ;
                alarm.device_id = device.id ;

                _this.commit("reporters/set_alarm", alarm) ; 

              });

            });

          });

        });

      });

    }
    
    state.reporters = reporters

  },

  set_reporter_status (state, data) {

    let reporterIndex = state.reporters.findIndex(function( obj ) {
        return obj.id === data.reporter_id;
    });

    if(typeof data.status != undefined){
      state.reporters[reporterIndex].status = data.status ;
    }

    // console.log(reporterIndex);

    // if(reporterIndex !== -1){
    //   state.reporters.splice(reporterIndex, 1, tag) ;
    // }else{
    //   state.reporters.push(tag) ;
    // }
    
    // console.log('set_reporter_status');
    // console.log(data.reporter_id);
    // console.log(data.status);

  },

  set_alarm(state, alarm){

    let index = state.alarms.findIndex(function( obj ) {
        return obj.id === alarm.id;
    });

    if(index !== -1){
      state.alarms.splice(index, 1, alarm) ;
    }else{
      state.alarms.push(alarm) ;
    }

    // count alarm prios
    let prio0Alarms = state.alarms.filter(function( obj ) {
      return obj.alarm_prio == 0 ;
    });

    state.alarm_stats.prio0 = prio0Alarms.length ;

    // count alarm prios
    let prio1Alarms = state.alarms.filter(function( obj ) {
      return obj.alarm_prio == 1 ;
    });

    state.alarm_stats.prio1 = prio1Alarms.length ;

  },

  set_devices(state, devices){
    state.devices = devices ;
  },

  set_alarms(state, alarms){
    
    state.alarms = alarms ;

    if(alarms.length == 0){

      state.alarm_stats.prio0 = 0 ;
      state.alarm_stats.prio1 = 0 ;

    } 

  },

}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}